import React from 'react';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import EditableCell from 'main/components/show/cuesheet/editableCell.jsx';
import ColumnMenu from 'main/components/show/cuesheet/columnHeaderCell/dataColumnMenu.jsx';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

/**
 * Data header cell
 *
 */
export default React.createClass({
  displayName: 'DataColumnHeaderCell',

  propTypes: {
    column: React.PropTypes.any.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    label: React.PropTypes.string.isRequired,
    teamId: React.PropTypes.string.isRequired,
    eventId: React.PropTypes.string.isRequired,
    showId: React.PropTypes.string.isRequired,
  },

  render() {
    const { teamId, eventId, showId } = this.props;

    return (
      <div className="cs-data-header-cell-wrapper">
        <EditableCell
          onSelect={this._select}
          onStartEdit={this._startEditing}
          onStopEdit={this._stopEditing}
          text={this._getCellText()}
          resizeWhenEditing={false}
          extraClassName="cs-header-cell"
          {...this.props}
        />
        <WithTooltip placement="top" tip={TooltipConstants.CSHeaderCell}>
          <div className="caret-right">
            <ColumnMenu
              {...{ teamId, eventId, showId }}
              column={this.props.column}
            />
          </div>
        </WithTooltip>
      </div>
    );
  },

  _getColumnId() {
    return this.props.column.get('_id');
  },

  _getCellText() {
    return this.props.column.get('title');
  },

  _select() {
    CuesheetCellActions.selectHeaderCell(this._getColumnId());
  },

  _startEditing() {
    CuesheetCellActions.startEditingHeaderCell(this._getColumnId());
  },

  _stopEditing(heightAndText) {
    CuesheetCellActions.saveHeaderCellChanges(
      this._getColumnId(),
      heightAndText.text,
    );
  },
});
